import LocaleZooms from './LocaleZooms';

export default LocaleZooms;